class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);


if (!customElements.get('product-result')) {

    class ProductResult extends SearchForm {

        constructor() {
            super();

            

            if(window.innerWidth < 749){
                this.itemsPerPage = 9;
            }else{
                this.itemsPerPage = 8;
            }

            this.currentPage = 1;

            this.productList = this.querySelector('.product-grid');
            this.items = this.querySelectorAll('.product-grid .grid__item');

            this.paginationWrapper = this.querySelector('.product-pagination');

            this.prevBtn = this.querySelector('.product-pagination .prev');
            this.nextBtn = this.querySelector('.product-pagination .next');
            this.pageNumbers = this.querySelector('.product-pagination .page-numbers');

            this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);

            if (!this.items.length) return;

            this.init();
        }

        init() {

            // hide pagination if only one page
            if (this.totalPages <= 1) {

                if (this.paginationWrapper) {
                    this.paginationWrapper.style.display = 'none';
                }

            } else {

                if (this.paginationWrapper) {
                    this.paginationWrapper.style.display = '';
                }

            }

            this.showPage(this.currentPage);

            this.prevBtn?.addEventListener('click', () => {
                this.prevPage();
            });

            this.nextBtn?.addEventListener('click', () => {
                this.nextPage();
            });
        }

        showPage(page) {

            this.currentPage = page;

            const start = (page - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;

            this.items.forEach((item, index) => {

                if (index >= start && index < end) {
                    item.style.display = '';
                } else {
                    item.style.display = 'none';
                }

            });

            this.renderPagination();

            this.updateButtons();
        }

        renderPagination() {

            if (!this.pageNumbers || this.totalPages <= 1) return;

            this.pageNumbers.innerHTML = '';

            const total = this.totalPages;
            const current = this.currentPage;

            const createButton = (page) => {

                const button = document.createElement('button');

                button.type = 'button';
                button.className = 'page-number';

                if (page === current) {
                    button.classList.add('active');
                }

                button.textContent = page;

                button.addEventListener('click', () => {
                    this.showPage(page);
                });

                this.pageNumbers.appendChild(button);
            };

            const createDots = () => {

                const dots = document.createElement('span');

                dots.className = 'pagination-dots';
                dots.textContent = '...';

                this.pageNumbers.appendChild(dots);
            };

            // first page
            createButton(1);

            // left dots
            if (current > 4) {
                createDots();
            }

            // middle pages
            let start = Math.max(2, current - 1);
            let end = Math.min(total - 1, current + 1);

            // near start
            if (current <= 4) {
                start = 2;
                end = Math.min(5, total - 1);
            }

            // near end
            if (current >= total - 3) {
                start = Math.max(2, total - 4);
                end = total - 1;
            }

            for (let i = start; i <= end; i++) {

                if (i > 1 && i < total) {
                    createButton(i);
                }
            }

            // right dots
            if (current < total - 3) {
                createDots();
            }

            // last page
            if (total > 1) {
                createButton(total);
            }
        }

        prevPage() {

            if (this.currentPage > 1) {
                this.showPage(this.currentPage - 1);
            }
        }

        nextPage() {

            if (this.currentPage < this.totalPages) {
                this.showPage(this.currentPage + 1);
            }
        }

        updateButtons() {

            if (this.prevBtn) {
                this.prevBtn.disabled = this.currentPage === 1;
            }

            if (this.nextBtn) {
                this.nextBtn.disabled = this.currentPage === this.totalPages;
            }
        }
    }

    customElements.define('product-result', ProductResult);
}


if (!customElements.get('article-result')) {

    class articleResult extends SearchForm {

        constructor() {
            super();

            this.itemsPerPage = 6;
            this.currentPage = 1;

            this.articleList = this.querySelector('.article-grid');
            this.items = this.querySelectorAll('.article-grid .grid__item');

            this.paginationWrapper = this.querySelector('.article-pagination');

            this.prevBtn = this.querySelector('.article-pagination .prev');
            this.nextBtn = this.querySelector('.article-pagination .next');
            this.pageNumbers = this.querySelector('.article-pagination .page-numbers');

            this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);

            if (!this.items.length) return;

            this.init();
        }

        init() {

            // hide pagination if only one page
            if (this.totalPages <= 1) {

                if (this.paginationWrapper) {
                    this.paginationWrapper.style.display = 'none';
                }

            } else {

                if (this.paginationWrapper) {
                    this.paginationWrapper.style.display = '';
                }

            }

            this.showPage(this.currentPage);

            this.prevBtn?.addEventListener('click', () => {
                this.prevPage();
            });

            this.nextBtn?.addEventListener('click', () => {
                this.nextPage();
            });
        }

        showPage(page) {

            this.currentPage = page;

            const start = (page - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;

            this.items.forEach((item, index) => {

                if (index >= start && index < end) {
                    item.style.display = '';
                } else {
                    item.style.display = 'none';
                }

            });

            this.renderPagination();

            this.updateButtons();
        }

        renderPagination() {

            if (!this.pageNumbers || this.totalPages <= 1) return;

            this.pageNumbers.innerHTML = '';

            const total = this.totalPages;
            const current = this.currentPage;

            const createButton = (page) => {

                const button = document.createElement('button');

                button.type = 'button';
                button.className = 'page-number';

                if (page === current) {
                    button.classList.add('active');
                }

                button.textContent = page;

                button.addEventListener('click', () => {
                    this.showPage(page);
                });

                this.pageNumbers.appendChild(button);
            };

            const createDots = () => {

                const dots = document.createElement('span');

                dots.className = 'pagination-dots';
                dots.textContent = '...';

                this.pageNumbers.appendChild(dots);
            };

            // first page
            createButton(1);

            // left dots
            if (current > 4) {
                createDots();
            }

            // middle pages
            let start = Math.max(2, current - 1);
            let end = Math.min(total - 1, current + 1);

            // near start
            if (current <= 4) {
                start = 2;
                end = Math.min(5, total - 1);
            }

            // near end
            if (current >= total - 3) {
                start = Math.max(2, total - 4);
                end = total - 1;
            }

            for (let i = start; i <= end; i++) {

                if (i > 1 && i < total) {
                    createButton(i);
                }
            }

            // right dots
            if (current < total - 3) {
                createDots();
            }

            // last page
            if (total > 1) {
                createButton(total);
            }
        }

        prevPage() {

            if (this.currentPage > 1) {
                this.showPage(this.currentPage - 1);
            }
        }

        nextPage() {

            if (this.currentPage < this.totalPages) {
                this.showPage(this.currentPage + 1);
            }
        }

        updateButtons() {

            if (this.prevBtn) {
                this.prevBtn.disabled = this.currentPage === 1;
            }

            if (this.nextBtn) {
                this.nextBtn.disabled = this.currentPage === this.totalPages;
            }
        }
    }

    customElements.define('articles-result', articleResult);
}


document.addEventListener('DOMContentLoaded', async () => {

  const params = new URLSearchParams(window.location.search);
  const query = params.get('q');
  if (!query) return;
  const container = document.querySelector('.template-search__body');

  try {

    const response = await fetch(`/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=20&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=custom-predictive-search`);

    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');

    const tab_results = html.querySelector('.template-search-tab');
    if (tab_results) {
      container.querySelector('.template-search-tab').innerHTML = tab_results.innerHTML;
    }

    const content_results = html.querySelector('.template-search__result-item');
    if (content_results) {
      container.querySelector('.template-search__result-item').innerHTML = content_results.innerHTML;
    }

    if(tab_results == null && content_results == null){
      container.querySelector('.template-search__grid').classList.add('empty-search-template');
    }else{
      container.querySelector('.template-search__grid').classList.remove('empty-search-template');
    }

    

    

  } catch(error) {
    console.log(error);
  } finally {
    document.querySelectorAll('.search-tab-item').forEach(button => {
      button.addEventListener('click', () => {
        const tab = button.dataset.type;
        document.querySelectorAll('.search-tab-item').forEach(btn => {
          btn.classList.remove('is--active');
        });
        document.querySelectorAll('.search-result-item').forEach(content => {
          content.classList.remove('is--active');
        });
        button.classList.add('is--active');
        if(document.querySelector('.search-result-item[data-type="'+tab+'"]') != null){
            document.querySelector('.search-result-item[data-type="'+tab+'"]').classList.add('is--active');
        }
      });
    });
  }

});